import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { ConnectedApp } from './useConnectedApps';
import { ConnectedAppRow } from './ConnectedAppRow';
import { PanelFoot } from '../../../../music24/components/primitives/Panel';
import { aiAssistantsMessages as messages } from '../aiAssistantsMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the API tab; each part uses its own slice of it */
import apiStyles from '../../apiAccess/apiAccess.module.scss';
/* eslint-enable css-modules/no-unused-class */
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the connected-apps parts; each part uses its own slice of it */
import styles from './connectedApps.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ConnectedAppsListProps {
  apps: ConnectedApp[];
  onRevoke: (clientId: string) => void;
  revokingClientId: string | null;
}

/** design: ai-assistants a2 — the column heads, one row per assistant, and the note under the list. */
const ConnectedAppsListComponent: React.FC<ConnectedAppsListProps> = ({ apps, onRevoke, revokingClientId }) => {
  const intl = useIntl();
  return (
    <div className={apiStyles.tokens}>
      <div className={`${styles.appRow} ${styles.appRowHead}`}>
        <span>{intl.formatMessage(messages.columnAssistant)}</span>
        <span>
          {intl.formatMessage({ id: 'app.sml.settings.connectedApps.columnApproved', defaultMessage: 'Approved' })}
        </span>
        <span>
          {intl.formatMessage({ id: 'app.sml.settings.connectedApps.columnLastUsed', defaultMessage: 'Last used' })}
        </span>
        <span>
          {intl.formatMessage({ id: 'app.sml.settings.connectedApps.columnAccess', defaultMessage: 'Access' })}
        </span>
        <span aria-hidden="true" />
      </div>
      {apps.map((app) => (
        <ConnectedAppRow
          key={app.clientId}
          app={app}
          onRevoke={onRevoke}
          isRevoking={revokingClientId === app.clientId}
        />
      ))}
      <PanelFoot>{intl.formatMessage(messages.connectedFootnote)}</PanelFoot>
    </div>
  );
};

export const ConnectedAppsList = TypedMemo(ConnectedAppsListComponent);
